import { api, ApiError } from './api.js';
import { setAppTimezone, todayYmd } from './time.js';
import * as M from './mapping.js';
import { applyServerData } from './design/data.jsx';

/**
 * 화면에 필요한 데이터를 한 번에 받아 시안 형태로 바꾼다.
 * 미인증(401)이면 ApiError를 그대로 올려보내 호출부가 로그인으로 보낸다.
 */
export async function loadAll() {
  const me = await api.get('/api/v1/me');          // 401이면 여기서 throw
  setAppTimezone(me.appTimezone);                   // 화면의 날짜·시각은 앱 시간대로(계획 문서 5.3 3d)
  const today = todayYmd();                         // 앱 시간대의 오늘

  const [depts, users, approvalSummary, facilities, bookings, leaveBal, leaveMine,
         posts, tasks, taskSummary, notifs, services, preferences, policy] = await Promise.all([
    api.get('/api/v1/org/departments'),
    api.get('/api/v1/org/users'),
    api.get('/api/v1/approvals/summary'),
    api.get('/api/v1/facilities'),
    api.get(`/api/v1/bookings?date=${today}`),
    api.get('/api/v1/leave/balance'),
    api.get('/api/v1/leave/requests'),
    api.get('/api/v1/posts'),
    api.get('/api/v1/tasks'),
    api.get('/api/v1/tasks/summary'),
    api.get('/api/v1/notifications'),
    // 서비스 목록을 못 받아도 그룹웨어는 쓴다 — 런처가 오류를 보인다(삼키지 않는다)
    api.get('/api/v1/services').catch((e) => ({ services: [], error: e.message })),
    api.get('/api/v1/me/preferences'),
    api.get('/api/v1/policy')
  ]);

  const meMapped = M.mapMe({
    ...me.user,
    departmentName: depts.departments.find((d) => d.id === me.user.departmentId)?.name ?? ''
  });

  applyServerData({
    me: meMapped,
    firstView: me.firstView ?? 'home',
    features: me.features ?? {},
    policy,
    depts: M.mapDepts(depts.departments),
    people: M.mapPeople(users.users),
    approvalSummary,
    rooms: M.mapRooms(facilities.facilities),
    bookings: M.mapBookings(bookings.bookings, meMapped.id, today),
    leave: M.mapLeave(leaveBal, leaveMine.requests),
    posts: M.mapPosts(posts.posts),
    tasks: M.mapTasks(tasks.tasks),
    taskSummary,
    notifs: M.mapNotifs(notifs.notifications),
    services: services.services,
    servicesError: services.error ?? null,
    preferences: preferences.preferences
  });
}

export { ApiError };
